import React from 'react';
import { observer, Observer, inject } from 'mobx-react';
import { toJS, action } from 'mobx';
import moment from 'moment';

import { SiteHeader } from '../component/SiteHeader';
import { SiteFooter } from '../component/SiteFooter';
import { PreventParentScroll } from '../component/PreventParentScroll';
import { Focuspoint } from '../component/Focuspoint';
import { Dropdown } from '../component/Dropdown';
import { DayPicker } from '../component/DayPicker';
import { StickInParent } from '../component/StickInParent';

import * as constants from '../../model/const';

import { fmtPrice, fmtPercent, fmtDatetime, fmtDate, fmtTime } from '../../model/formatters';
import translateBase from '../../translate';
let translate = translateBase.bindPage('userBookingDetail');

@inject(stores => ({
  navigation: stores.app.navigation,
  vRecentBookingDetail: stores.app.vRecentBookingDetail,
  rentalObject: stores.app.rentalObject,
}))
@observer
export class RecentBookingDetail extends React.Component {
  render() {
    const { navigation, vRecentBookingDetail, rentalObject } = this.props;
    const { detail } = vRecentBookingDetail;
    var cancelHours = detail.cancellationFees.map(fee => fee.minHoursPP);
    let cancelTimeunit = Math.max.apply(Math, cancelHours) >= 48 ? 'DAYS' : 'HOURS';
    //const currency = 'CHF';
    const VAT = 7.7;

    const isCancellable = () => {
      if (detail.transactionStatusId === constants.BOOKING_STATUS_TYPE.BOOKED) {
          const currentTime = new Date().getTime();
          const rentingStartTime = new Date(detail.bookingStartDate).getTime();
          return currentTime < rentingStartTime;
      }
      return false;
  }

    //const bookingDetails = vRecentBookingDetail.recentBookingDetailContent;
    return (
      <div>
        {/*<div>
          <pre>
            {JSON.stringify(toJS(this.props.searchForm.optLocation), null, 2)}
            {JSON.stringify(toJS(this.props.searchForm.optCategory), null, 2)}
            {JSON.stringify(toJS(this.props.searchForm.optSubcategory), null, 2)}
            {JSON.stringify(toJS(this.props.searchForm.optOrgTimeUnit), null, 2)}
          </pre>
        </div>*/}

        <SiteHeader />

        <StickInParent>{({ ref: sipRef }) => <Observer>{() =>
          <section className="my-bookings-filter-container sticky-container" ref={sipRef}>
            <div className="filter-header-wrapper">
              <div className="wrapper">
                <div className="row">
                  <div className="column-12">
                    <a href="#/recentBookings" className="back"><i className="fa fa-arrow-left" aria-hidden="true"></i> {translate("back", "Zurück")}</a>
                    <a href={`/api/Lessee/RentalTransaction/${vRecentBookingDetail.trxId}/BillReport`}
                      target="_blank" className="print">{translate("performPrint", "Drucken")} <i className="fa fa-print" aria-hidden="true"></i></a>
                    {isCancellable() &&
                      <a onClick={() => vRecentBookingDetail.cancelBooking()}
                        className="cancel">{translate("performCancel", "Stornieren")} <i className="fa fa-times" aria-hidden="true"></i></a>
                    }
                  </div>
                </div>
              </div>
            </div>
          </section>
        }</Observer>}</StickInParent>

        <section className="my-bookings-container">
          <div className="wrapper">
            <div className="main-details-container">

              <div className="row">
                <div className="column-8">
                  <div className="product-container">
                    <figure className="product-image">
                      <div className="spacer"></div>
                      <Focuspoint
                        src={rentalObject.thumbnailUrl}
                        imageW={756}
                        imageH={415}
                        focusX={0.0}
                        focusY={0.0}
                        reCalcOnWindowResize={true}
                      />
                    </figure>

                    <div className="product-details">
                      <div className="product-name biggest">
                        {detail.name}
                      </div>
                      <div className="product-total">
                        <div className="label">{translate("mietbetrag", "Mietbetrag")}</div>
                        <div className="amount number">{detail.currency} {fmtPrice(detail.totalPrice)}{" "}
                          <span className="amount-note">{translate("vatIncluded", "inkl. Mwst.")}</span>
                        </div>
                        <div className="price-detail-trigger">
                          <a><i className="fa fa-info" aria-hidden="true"></i></a>
                        </div>
                      </div>
                      <div className="product-location">
                        <i className="fa fa-map-marker" aria-hidden="true"></i> {rentalObject.businessUnitName}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="column-4">
                  <div className="bookingdates-container">
                    <div className="booking-center">
                      <div className="from">
                        <div className="label">{translate("bookedFrom", "Buchung von")}</div>
                        <div className="value">{fmtDatetime(detail.bookingStartDate)}</div>
                      </div>
                      <div className="till">
                        <div className="label">{translate("bookedTo", "bis")}</div>
                        <div className="value">{fmtDatetime(detail.bookingEndDate)}</div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="column-12">
                  <div className="bookingdetails-container">
                    <div className="column-4">
                      <div className="label">{translate("bookingNumber", "Buchungs-Nr.")}</div>
                      <div className="value">{detail.bookingNumber}</div>
                    </div>
                    <div className="column-4">
                      <div className="label">{translate("bookingState", "Status")}</div>
                      <div className="value">{detail.transactionStatus}</div>
                    </div>
                    <div className="column-4">
                      <div className="label">{translate("bookingSaldo", "Zahlungssaldo")}</div>
                      <div className={"value number" + (parseFloat(detail.paymentBalance) > 0 ? " negative" : "")}>
                        {detail.currency} {fmtPrice(detail.paymentBalance)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {detail.mainObjectOffers.length > 0 && <div className="row with-table">
                <div className="column-12">
                  <div className="title">{translate("objectAndAccessories", "Mietobjekt und Zubehör")}</div>
                  <div className="table">
                    <div className="tableheader">
                      <div className="tabledata column-4">
                        {translate("description", "Beschreibung")}
                      </div>
                      <div className="tabledata column-2 center">
                        {translate("count", "Anzahl")}
                      </div>
                      <div className="tabledata column-2 center">
                        {translate("offer", "Angebot")}
                      </div>
                      <div className="tabledata column-2 center">
                        {translate("season", "Saison")}
                      </div>
                      <div className="tabledata column-2 right">
                        {translate("price", "Preis")}
                      </div>
                    </div>
                    {detail.mainObjectOffers.map(offer => {
                      return (
                        <div className="tablerow" key={offer.id}>
                          <div className="tabledata column-4">
                            {offer.name}
                            {offer.prolongationOfferQuantity > 0 &&
                              <div className="prolongation">
                                {offer.prolongationName}
                              </div>}
                          </div>
                          <div className="tabledata column-2 center">
                            {offer.offerQuantity > 0 ? offer.offerQuantity : "-"}
                            {offer.prolongationOfferQuantity > 0 &&
                              <div className="prolongation">
                                {offer.prolongationOfferQuantity}
                              </div>}
                          </div>
                          <div className="tabledata column-2 center">
                            {offer.offerName}
                          </div>
                          <div className="tabledata column-2 center">
                            {offer.seasonName}
                          </div>
                          <div className="tabledata column-2 right number">
                            {detail.currency}&nbsp;{fmtPrice(offer.price)}
                          </div>
                        </div>
                      )
                    })}

                    {detail.accessoryOffers.map(offer => {
                      return (
                        <div className="tablerow" key={offer.id}>
                          <div className="tabledata column-4">
                            {offer.name}
                          </div>
                          <div className="tabledata column-2 center">
                            {offer.offerQuantity > 0 ? offer.offerQuantity : "-"}
                          </div>
                          <div className="tabledata column-2 center">
                            {offer.offerName}
                          </div>
                          <div className="tabledata column-2 center">
                            {offer.seasonName}
                          </div>
                          <div className="tabledata column-2 right number">
                            {detail.currency}&nbsp;{fmtPrice(offer.price)}
                          </div>
                        </div>
                      )
                    })}


                    {/*
                                <div className="tablerow">
                                    <div className="tabledata column-5">
                                        Fendt 1000 Vario
                                    </div>
                                    <div className="tabledata column-2 center">
                                        1 Woche
                                    </div>
                                    <div className="tabledata column-2 center">
                                        Basis
                                    </div>
                                    <div className="tabledata column-3 right number">
                                        CHF 2270.00
                                    </div>
                                </div>
                                <div className="tablerow">
                                    <div className="tabledata column-5">
                                        500 Kilometer-Paket
                                    </div>
                                    <div className="tabledata column-2 center">
                                        Spezial Rabatt
                                    </div>
                                    <div className="tabledata column-2 center">
                                        Basis
                                    </div>
                                    <div className="tabledata column-3 right number">
                                        CHF 530.00
                                    </div>
                                </div>*/}
                    <div className="tablefooter total-cost">
                      <div className="tabledata column-6">
                        {translate("subTotal", "Zwischensumme")}
                      </div>
                      <div className="tabledata column-6 right number">
                        {detail.currency}&nbsp;{fmtPrice(detail.subtotalMainObjectAndAccessories)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              }

              {detail.servicesConditioned.length > 0 && <div className="row with-table">
                <div className="column-12">
                  <div className="title">{translate("conditionalServices", "Bedingte Gebühren")}</div>
                  <div className="table">
                    <div className="tableheader">
                      <div className="tabledata column-4">
                        {translate("article", "Artikel")}
                      </div>
                      <div className="tabledata column-6">
                        {translate("description", "Beschreibung")}
                      </div>
                      <div className="tabledata column-2 right">
                        {translate("price", "Preis")}
                      </div>
                    </div>
                    {detail.servicesConditioned.map(service => {
                      return (
                        <div className={"tablerow" + (service.fixedPrice < 0 ? " discount" : "")} key={service.id}>
                          <div className="tabledata column-4">
                            {service.name}
                          </div>
                          <div className="tabledata column-6">
                            {service.description}
                          </div>
                          <div className="tabledata column-2 right number">
                            {detail.currency}&nbsp;{fmtPrice(service.fixedPrice)}
                          </div>
                        </div>
                      )
                    })}
                    <div className="tablefooter total-cost">
                      <div className="tabledata column-6">
                        {translate("subtotal", "Zwischensumme")}
                      </div>
                      <div className="tabledata column-6 right number">
                        {detail.currency} {fmtPrice(detail.subtotalServicesConditioned)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              }

              {detail.servicesUnconditioned.length > 0 && <div className="row with-table">
                <div className="column-12">
                  <div className="title">{translate("services", "Dienstleistungen")}</div>
                  <div className="table">
                    <div className="tableheader">
                      <div className="tabledata column-4">
                        {translate("article", "Artikel")}
                      </div>
                      <div className="tabledata column-6">
                        {translate("description", "Beschreibung")}
                      </div>
                      <div className="tabledata column-2 right">
                        {translate("price", "Preis")}
                      </div>
                    </div>
                    {detail.servicesUnconditioned.map(service => {
                      return (
                        <div className={"tablerow" + (service.fixedPrice < 0 ? " discount" : "")} key={service.id}>
                          <div className="tabledata column-4">
                            {service.name} {(service.fixedPrice < 0 && service.typeId === constants.SERVICE_TYPE.OBLIGATORISCH) && <span>{translate("discount", "Rabatt")}</span>}
                          </div>
                          <div className="tabledata column-6">
                            {service.description}
                          </div>
                          <div className="tabledata column-2 right number">
                            {detail.currency}&nbsp;{fmtPrice(service.fixedPrice)}
                          </div>
                        </div>
                      )
                    })}
                    <div className="tablefooter total-cost">
                      <div className="tabledata column-6">
                        {translate("subtotal", "Zwischensumme")}
                      </div>
                      <div className="tabledata column-6 right number">
                        {detail.currency} {fmtPrice(detail.subtotalServicesUnconditioned)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              }

              {detail.deposit &&
                <div className="row with-table">
                  <div className="column-12">
                    <div className="title">{translate("deposit", "Kaution")}</div>
                    <div className="table">
                      <div className={"tablerow"}>
                        <div className="tabledata column-6">
                          {translate("deposit", "Kaution")}
                        </div>
                        <div className="tabledata column-6 right number">
                          {detail.currency}&nbsp;{fmtPrice(detail.deposit)}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }

              {detail.consumables.length > 0 && <div className="row with-table">
                <div className="column-12">
                  <div className="title">{translate("consumables", "Nutzung")}</div>
                  <div className="table">
                    <div className="tableheader">
                      <div className="tabledata column-4">
                        {translate("consumableName", "Bezeichnung")}
                      </div>
                      <div className="tabledata column-2 center">
                        {translate("unit", "Einheit")}
                      </div>
                      <div className="tabledata column-2 center">
                        {translate("minIncl", "Min. / Inkl.")}
                      </div>
                      <div className="tabledata column-2 center">
                        {translate("pricePerUnit", "Preis / Einheit")}
                      </div>
                      <div className="tabledata column-2 right">
                        {translate("price", "Preis")}
                      </div>
                    </div>
                    {detail.consumables.map(consumable => {
                      return (
                        <div className="tablerow">
                          <div className="tabledata column-4">
                            {consumable.name}
                          </div>
                          <div className="tabledata column-2 center">
                            {consumable.unit}
                          </div>
                          <div className="tabledata column-2 center number">
                            {parseFloat(consumable.minQuantity).toFixed(2)} / {parseFloat(consumable.freeUnitQuantitySum).toFixed()}
                          </div>
                          <div className="tabledata column-2 center number">
                            {fmtPrice(consumable.pricePerUnit)}
                          </div>
                          <div className="tabledata column-2 number right number">
                            {fmtPrice(consumable.price)}
                          </div>
                        </div>
                      )
                    })}

                    <div className="tablefooter total-cost">
                      <div className="tabledata column-6">
                        {translate("subtotal", "Zwischensumme")}
                      </div>
                      <div className="tabledata column-6 right number">
                        {detail.currency} {fmtPrice(detail.subtotalConsumables)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              }

              {detail.extras.length > 0 && <div className="row with-table">
                <div className="column-12">
                  <div className="title">{translate("extras", "Extras")}</div>
                  <div className="table">
                    <div className="tableheader">
                      {/*<div className="tabledata column-2">
                        {translate("count", "Anzahl")}
                      </div>*/}
                      <div className="tabledata column-10">
                        {translate("priceShiftName", "Belastung / Rabatt")}
                      </div>
                      <div className="tabledata column-2 right">
                        {translate("price", "Preis")}
                      </div>
                    </div>
                    {detail.extras.map(extra =>
                      <div className={"tablerow" + (extra.price < 0 ? " discount" : "")}>
                        {/*<div className="tabledata column-2 number">
                          1
                          {extra.count}
                        </div>*/}
                        <div className="tabledata column-10">
                          {extra.name}
                        </div>
                        <div className="tabledata column-2 number right number">
                          {fmtPrice(extra.price)}
                        </div>
                      </div>
                    )}
                    <div className="tablefooter total-cost">
                      <div className="tabledata column-6">
                        {translate("subTotal", "Zwischensumme")}
                      </div>
                      <div className="tabledata column-6 right number">
                        {detail.currency}&nbsp;{fmtPrice(detail.subtotalExtras)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>}

              {detail.cancellationFees.length > 0 && <div className="row with-table">
                <div className="column-12">
                  <div className="title">{translate("stornoGebuhren", "Storno-Gebühren")}</div>
                  <div className="table">
                    <div className="tableheader">
                      <div className="tabledata column-4">
                        {cancelTimeunit=='DAYS' && <div className="day">{translate("daysToPickup", "Tage bis zur Übernahme, oder früher")}</div>}
                        {cancelTimeunit=='HOURS' && <div className="day">{translate("hoursToPickup", "Stunden bis zur Übernahme, oder früher")}</div>}
                      </div>
                      <div className="tabledata column-4 right">
                        {translate("percent", "Prozent")}
                      </div>
                      <div className="tabledata column-4 right">
                        {translate("fix", "Fix")}
                      </div>
                    </div>
                    {detail.cancellationFees.map(fee => {
                      return (
                        <div className="tablerow" key={`${fee.minHoursPP}_${fee.rate}_${fee.fix}`}>
                          <div className="tabledata column-4">
                            <div className="day">{cancelTimeunit=='DAYS' ? fee.minHoursPP/24 : fee.minHoursPP}</div>
                          </div>
                          <div className="tabledata column-4 right number">
                            {fmtPercent(fee.rate)}%
                          </div>
                          <div className="tabledata column-4 right number">
                            {fmtPrice(fee.fix)}
                          </div>
                        </div>
                      )
                    })}
                  </div>
                </div>
              </div>
              }

              {detail.totalDiscount < 0 &&
                <div className="row with-table">
                  <div className="column-12">
                    <div className="title">{translate("totalDiscount", "Total Rabatt")}</div>
                    <div className="table">
                      <div className="tablerow discount">
                        <div className="tabledata column-6">
                        {translate("discount", "Rabatt")}
                        </div>
                        <div className="tabledata column-6 right number">
                          {detail.currency}&nbsp;{fmtPrice(detail.totalDiscount)}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }

              <div className="row with-table">
                <div className="column-12">
                  <div className="table final-cost">
                    <div className="tablerow">
                      <div className="tabledata title column-9">
                        {translate("bookingTotalPrice", "Buchungstotal")}
                      </div>
                      <div className="tabledata column-3 number right number">
                        {detail.currency} {fmtPrice(detail.totalPrice)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row with-table">
                <div className="column-12">
                  <div className="title">{translate("billingAmount", "Rechnungsbetrag")}</div>
                  <div className="table">
                    <div className="tablerow main-payment">
                      <div className="tabledata text column-9">
                        {translate("gesamtbetragFallig", "Gesamtbetrag, fällig")} {fmtDate(detail.fullpaymentDueDate)}
                      </div>
                      <div className="tabledata column-3 right number">
                        {detail.currency} {fmtPrice(detail.totalPrice)}
                      </div>
                    </div>
                    <div className="tablerow tax">
                      <div className="tabledata text column-9">
                        {translate("enthalteneMwst", "Enthaltene MwSt (${vatPercentage}%)", { vatPercentage: fmtPercent(detail.vatRate) })}
                      </div>
                      <div className="tabledata column-3 right number">
                        {detail.currency} {fmtPrice(detail.vatAmount)}
                      </div>
                    </div>
                    <div className="tablerow">
                      <div className="tabledata column-9">
                        {translate("anzahlungFallig", "Anzahlung, fällig")} {fmtDate(detail.downpaymentDueDate)}
                      </div>
                      <div className="tabledata column-3 right number">
                        {detail.currency}&nbsp;{fmtPrice(detail.downpaymentAmount)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {detail.payments.length > 0 && <div className="row with-table">
                <div className="column-12">
                  <div className="title">{translate("receivedPayments", "Erhaltene Zahlungen")}</div>
                  <div className="table">
                    {detail.payments.map(payment => {
                      return (
                        <div className="tablerow">
                          <div className="tabledata column-2 number">
                            {fmtDate(payment.date)}
                          </div>
                          <div className="tabledata column-7">
                            {payment.description}
                          </div>
                          <div className="tabledata column-3 right number">
                            {detail.currency} {fmtPrice(payment.amount)}
                          </div>
                        </div>
                      )
                    })}
                  </div>
                </div>
              </div>
              }
            </div>
          </div>
        </section>



        {/*<section className="">
          <div className="wrapper">
            <div className="row">
              <div className="column-12">
                <pre>
                  {JSON.stringify(vRecentBookingDetail.recentBookingDetail, null, 2)}
                </pre>
              </div>
            </div>
          </div>
        </section>*/}

        <SiteFooter />
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/visual/view/RecentBookingDetail.js